// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2luvC","rootCenter":"LoadMoreObserver_rootCenter__ghNrV","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1piZn"};